import Modal, { ModalProps } from "components/Modal/Modal";
import React from "react";
import {
  ResponsiveSanityImage,
  SanityImageRatio
} from "@silversea-ssc/ui-components-react";
import { SpecialVoyageEventFragment } from "types/graphql-types";
import TextBox from "components/TextBox/TextBox";
import { ModalBody, ModalBodyTitle } from "@silversea-ssc/ui-components-react";

export interface CruiseEventModalProps extends ModalProps {
  event: SpecialVoyageEventFragment;
}

const CruiseEventModal: React.FC<CruiseEventModalProps> = ({
  modal,
  event
}) => {
  const { title, content, image } = event;
  return (
    <Modal
      title={title?.localized || ""}
      modal={modal}
      size="medium"
      data-content-name={`modal_cruise_event_${title?.en}`}
    >
      <ModalBody variant="wide">
        {image && (
          <SanityImageRatio ratio="auto" image={image}>
            <ResponsiveSanityImage
              image={image}
              fit="original"
              defaultWidth={900}
              defaultHeight={600}
            />
          </SanityImageRatio>
        )}
        <br />
        <ModalBodyTitle>{title?.localized}</ModalBodyTitle>

        <div>
          {content?.localized && (
            <TextBox content={content.localized} fontSize="medium" />
          )}
        </div>
        <br />
      </ModalBody>
    </Modal>
  );
};

export default CruiseEventModal;
